module.exports = __webpack_public_path__ + "img/success.7e042888.svg";